module.exports = __webpack_public_path__ + "static/MM_hiring cover photo-fe8e6ce29d02c7bf08383e9296e0cbf6.jpg";